export enum ThemeColors {
  light = 'light',
  dark = 'dark',
  lady = 'lady'
}

export interface IThemeState {
  colorTheme: ThemeColors;
}
